<template>
  <el-popover
    placement="right"
    :width="250"
    :offset="24"
    trigger="hover"
    popper-class="appointment-popover"
  >
    <template #reference>
      <slot />
    </template>
    <div v-if="appointment">
      <div class="popover-main">
        <div class="popover-title">
          <template v-if="appointment.client_name">
            {{ appointment.client_name }}
          </template>
          <template v-else>
            <span style="color: var(--cal-danger);">Клиент удалён</span>
          </template>
        </div>
        <div class="popover-phone">
          <template v-if="appointment.client_phone">
            {{ appointment.client_phone }}
          </template>
          <template v-else>
            <span style="color: var(--ui-color-text-disabled);">—</span>
          </template>
        </div>
        <div class="popover-services">
          <span v-for="srv in appointment.services" :key="srv.id">
            {{ srv.name }} <span v-if="srv.duration">({{ srv.duration }} мин)</span>
            <span v-if="!srv.last">, </span>
          </span>
        </div>
        <div class="popover-times">{{ appointment.start_time }}-{{ calcEnd }}</div>
        <div class="popover-status" :class="statusClass">{{ statusLabel }}</div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'AppointmentPopover',
  props: {
    appointment: { type: Object, required: true }
  },
  computed: {
    calcEnd() {
      const t = this.timeToMin(this.appointment.start_time)
      const duration = this.appointment.duration_time ||
        (this.appointment.services || []).reduce((s, x) => s + (x.duration || 0), 0)
      return this.formatTime(t + duration)
    },
    statusClass() {
      const st = this.appointment.status
      if (st) return `status-${st}`
      return `status-${this.getStatus(this.appointment)}`
    },
    statusLabel() {
      const STATUS_LABELS = {
        planned: 'Запланировано',
        confirmed: 'Подтверждено',
        done: 'Выполнено',
        no_show: 'Не пришёл',
        canceled: 'Отменено'
      }
      const st = this.appointment.status
      return STATUS_LABELS[st] || 'Статус не определён'
    }
  },
  methods: {
    timeToMin(str) {
      if (!str) return 0
      const [h, m] = str.split(':').map(Number)
      return h * 60 + m
    },
    formatTime(t) {
      const h = Math.floor(t / 60)
      const m = t % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },
    getStatus(app) {
      const now = new Date()
      const today = now.toISOString().slice(0, 10)
      const start = this.timeToMin(app.start_time)
      const duration = app.duration_time ||
        (app.services || []).reduce((sum, s) => sum + (s.duration || 0), 0)
      const end = start + duration
      const curr = now.getHours() * 60 + now.getMinutes()
      if (app.date < today || (app.date === today && end <= curr)) return 'past'
      if (app.date === today && start <= curr && curr < end) return 'current'
      return 'future'
    }
  }
}
</script>

<style>
.appointment-popover.el-popover.el-popper {
  --el-popover-bg-color: #123a78;
  --el-popover-border-color: transparent;
  font-size: 14px;
  padding: 14px 20px 16px;
  background: transparent !important;
  color: var(--cal-text-popover) !important;
  border: 0 !important;
  border-radius: 0;
  box-shadow: none !important;
  font-family: "Bahnschrift", var(--ui-font-family-base);
  overflow: visible !important;
  isolation: isolate;
}

.appointment-popover.el-popover.el-popper::before {
  content: "";
  position: absolute;
  z-index: 0;
  left: -20px;
  top: 0;
  width: calc(100% + 20px);
  height: 100%;
  background:
    linear-gradient(rgba(0, 108, 254, 0.22), rgba(0, 108, 254, 0.22)),
    linear-gradient(299deg, #030b1b 13.22%, #15264e 86.78%),
    #334878 !important;
  pointer-events: none;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1507 683' preserveAspectRatio='none'%3E%3Cpath fill='black' d='M90 0H1475C1492.7 0 1507 14.3 1507 32V651C1507 668.7 1492.7 683 1475 683H90C72.3 683 58 668.7 58 651V390L0 341.5L58 293V32C58 14.3 72.3 0 90 0Z'/%3E%3C/svg%3E") 0 0 / 100% 100% no-repeat;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1507 683' preserveAspectRatio='none'%3E%3Cpath fill='black' d='M90 0H1475C1492.7 0 1507 14.3 1507 32V651C1507 668.7 1492.7 683 1475 683H90C72.3 683 58 668.7 58 651V390L0 341.5L58 293V32C58 14.3 72.3 0 90 0Z'/%3E%3C/svg%3E") 0 0 / 100% 100% no-repeat;
}

.appointment-popover.el-popper .el-popper__arrow {
  display: none !important;
}

.appointment-popover.el-popper .el-popper__arrow::before {
  display: none !important;
}

.appointment-popover .popover-main {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: flex-start;
  text-align: left;
}

.appointment-popover .popover-title {
  font-weight: 300;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.1;
  margin-bottom: 4px;
}

.appointment-popover .popover-phone {
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.appointment-popover .popover-services,
.appointment-popover .popover-times {
  color: var(--lineon-accent);
  font-size: 12px;
  line-height: 1.15;
  margin-bottom: 3px;
  font-weight: 600;
}

.appointment-popover .popover-status {
  font-size: 18px;
  margin-top: 6px;
  color: #000713;
  font-weight: 600;
}

.appointment-popover .popover-status.past {
  color: rgba(0, 6, 20, 0.78);
}

.appointment-popover .popover-status.current {
  color: #ffffff;
}

.appointment-popover .popover-status.future {
  color: #000614;
}

.appointment-popover .popover-status.status-planned { color: #000713; }
.appointment-popover .popover-status.status-confirmed { color: #ffffff; }
.appointment-popover .popover-status.status-done { color: #8ff4bb; }
.appointment-popover .popover-status.status-no_show { color: #ff9898; }
.appointment-popover .popover-status.status-canceled { color: rgba(0, 7, 19, 0.78); }
</style>

